import Vue from 'vue'
import axios from 'axios'
import {Message} from 'element-ui'
import VueRouter from '../router'
axios.defaults.baseURL = process.env.API_ROOT
axios.interceptors.request.use(config => {
  	const token = sessionStorage.getItem('Token') // 获取存储在本地的token
  if (token) {
//  config.headers.Authorization = 'Bearer ' + token // 携带权限参数
  }
//if (store.state.user.token) {
// config.headers.Authorization = `token ${store.state.user.token}`;
//}
  return config
}, err => {
  return Promise.reject(err)
})
axios.interceptors.response.use(data => {
//if (data.status !== 200 && data.data.error !== 0) {
//  console.log(data)
//}
	
  return data
}, error => {
  
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误'
        break
      case 401:
        error.message = '授权失败，请请重新登录'
        VueRouter.replace({path: '/login'})
        return
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = `请求地址出错: ${error.response.config.url}`
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器内部错误'
        break
      case 501:
        error.message = '服务未实现'
        break
      case 502:
        error.message = '网关错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网关超时'
        break
      case 505:
        error.message = 'HTTP版本不受支持'
        break
      default:
    }
  }
//	console.log(error.message);
	Message(error.message);

	return Promise.reject(error)
})
export default {
  axios
}



// WEBPACK FOOTER //
// ./src/untils/http.js